import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { initialUpdateContactState } from "./ContactState";
import { UpdateRegion } from "../../app/data/terminal-details/models";

const terminalService = TerminalService.getInstance();

export const updateRegionSlice = createSlice({
    name: "updateRegion",
    initialState: initialUpdateContactState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setRegion: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        }
    },
});

export const {
    loading,
    setRegion,
    error
} = updateRegionSlice.actions;

export const updateRegionSelector = (state: IState) => state.updateRegion;

// update terminal region by region name
export const updateTerminalRegionById = (terminalNumber: string, regionId: string, data: UpdateRegion, onSuccess?: () => void, onError?: (message: string | object) => void): AppThunk => async (dispatch) => {
    if (!terminalNumber || !regionId) return
    dispatch(loading());
    const response = await terminalService.updateTerminalRegionById(terminalNumber, regionId, data);
    if (response.ok()) {
        dispatch(setRegion(response.data));
        onSuccess?.();
    } else {
        dispatch(error(response.getError()));
        if(typeof response.getError() === "string" && response.getError() !== "")
            onError?.(response?.getError() || "Error! Please try again later...");
        else
            onError?.("Error! Please try again later...");
    }
};

const updateRegionReducer = updateRegionSlice.reducer;
export default updateRegionReducer;
